import apiRequest from "@shared/services/api/apiRequest";
import type { VideoRoomAccessResponse } from "@platform/features/video/types/video.types";

export { VideoRoomAccessResponse };

export const verifyVideoRoomAccess = async (roomId: number): Promise<VideoRoomAccessResponse> => {
  return apiRequest(`/api/video-rooms/verify-access/?room_id=${roomId}`, "GET");
}; 